/* --------------------------------------------
リンクボタン
-------------------------------------------- */
export function hoverFunc() {
  $('#linkBtn').on('touchstart', function () {
    $(this).addClass('hover');
  }).on('touchend', function () {
    $(this).removeClass('hover');
  });
}